import { Field, Entity } from "typegraph";

@Entity({create: "topicFlag"})
export default class TopicFlag {

	@Field()
	entityId: number; // the topic id

}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/TopicFlag.ts